import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Europa({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18 7H18.7C18.8105 7 18.9 7.08954 18.9 7.2V9.8C18.9 9.91046 18.8105 10 18.7 10H18M6.5 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3H6.5C6.22386 3 6 3.22386 6 3.5V20.5C6 20.7761 6.22386 21 6.5 21Z" stroke="currentColor" strokeWidth={strokeWidth} /><text transform="matrix(0.567696 0 0 0.54061 3.40861 4.46363)" stroke="#000" textAnchor="start" fontSize={24} id="svg_2" y={22.18957} x={7.67184} strokeWidth={strokeWidth} fill="#ffffff">{"E"}</text></Svg>;
}
export default Europa;